<template>
    <SearchBox
        :label="(hidelabel) ? '' : 'Profissão:'"
        :hidelabel="hidelabel"
        ref="searchbox"
        placeholder="Busca Profissão por Nome ou Código"
        funcaoBuscar="getProfissoesBox"
        :incluir="incluir"
        :alterar="alterar"
        tipo="profissao"
        @selected="handleSelected"
    />
</template>

<style scoped></style>

<script>
import SearchBox from "./SearchBox.vue";

export default {
    name: "SearchBoxProfissao",
    data() {
        return {
            item: {}
        };
    },
    props: ["value", "incluir", "alterar", "hidelabel"],
    components: {
        SearchBox
    },
    methods: {
        handleSelected(item) {
            this.item = item;
            if (item.ID) {
                this.$emit("input", item.ID);
                this.$emit("descricao", item.DESCRICAO);
                this.$emit("update:modelValue", item.ID);
                this.$emit("change", {});
            } else {
                this.$emit("input", "");
                this.$emit("descricao", "");
                this.$emit("update:modelValue", "");
                this.$emit("change", {});
            }
        },
        selecionar(item) {
            this.item = item;
            this.$refs.searchbox.selecionarItemExterno(item);
        },
        apagar() {
            this.$refs.searchbox.apagar(true);
        },
        obterItem() {
            return this.item;
        }
    }
};
</script>